import React from "react";
import { Button } from "nq-component";

class Pagination extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      perPage: 10,
    };
  }

  handlePreviousPage = () => {
    this.setState(
      (prevState) => ({
        currentPage: Math.max(prevState.currentPage - 1, 1),
      }),
      () => {
        this.props.onPageChange(this.state.currentPage);
      }
    );
  };

  handleNextPage = () => {
    const totalPages = Math.ceil(this.props.totalObjects / this.state.perPage);
    this.setState(
      (prevState) => ({
        currentPage: Math.min(prevState.currentPage + 1, totalPages),
      }),
      () => {
        this.props.onPageChange(this.state.currentPage);
      }
    );
  };

  handlePerPageChange = (e) => {
    const perPage = parseInt(e.target.value);
    this.setState(
      {
        perPage,
        currentPage: 1,
      },
      () => {
        this.props.onPerPageChange(perPage);
        this.props.onPageChange(this.state.currentPage);
      }
    );
  };

  render() {
    const { currentPage, perPage } = this.state;
    const totalPages = Math.ceil(this.props.totalObjects / perPage);

    return (
      <div className="d-flex justify-content-center mt-4">
        <Button
          className="btn btn-outline-primary mx-1"
          onClick={this.handlePreviousPage}
          disabled={currentPage === 1}
        >
          Previous
        </Button>
        <Button className="btn btn-outline-primary " disabled>
          Page {currentPage} of {totalPages}
        </Button>
        <Button
          className="btn btn-outline-primary mx-1"
          onClick={this.handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </Button>
        <select
          className="btn btn-outline-primary"
          onChange={this.handlePerPageChange}
          value={perPage}
        >
          {[10, 20, 30].map((item) => (
            <option value={item} key={item}>
              {item} / page
            </option>
          ))}
        </select>
      </div>
    );
  }
}

export default Pagination;
